const miscellany = {
  boxShadow: '0px 3px 13px rgba(0, 0, 0, 0.18)',
  borderRadius: '11px',
};

export default miscellany;
